export default class PaginationService {

}
